import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  DocumentTextIcon,
} from "@heroicons/react/24/solid";

const TopMenu = () => {
  const location = useLocation();

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm w-full">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Link
              to="/dashboard"
              className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition ${
                location.pathname === '/dashboard'
                  ? 'text-brand-navy bg-brand-light'
                  : 'text-gray-600 hover:text-brand-navy hover:bg-gray-50'
              }`}
            >
              <svg
                className="w-5 h-5 mr-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 22 21"
              >
                <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
                <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
              </svg>
              Dashboard
            </Link>
            <Link
              to="/open-invoice"
              className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition ${
                location.pathname === '/open-invoice'
                  ? 'text-brand-navy bg-brand-light'
                  : 'text-gray-600 hover:text-brand-navy hover:bg-gray-50'
              }`}
            >
              <DocumentTextIcon className="h-5 w-5 mr-2" />
              Open Invoices
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default TopMenu;
